/* =========================================================================
   MediCarry - Shopify theme interactions
   ========================================================================= */

const FREE_SHIPPING_THRESHOLDS = { GBP: 40, EUR: 50, USD: 55, NOK: 540, CHF: 45 };
let FREE_SHIPPING_THRESHOLD = 40;
const URGENCY_KEY = 'heron.urgency.start';
const URGENCY_DURATION_MS = 10 * 60 * 1000;
const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

// ---------- Currency formatting (uses Shopify's localized format) ----------

let CART_CURRENCY = 'GBP';

function fmt(pence) {
  const value = pence / 100;
  const isWhole = value === Math.floor(value);
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: CART_CURRENCY,
      minimumFractionDigits: isWhole ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch (e) {
    return isWhole ? `£${Math.floor(value)}` : `£${value.toFixed(2)}`;
  }
}

const state = {
  bundle: 1,
  variantId: null,
  variantPrice: 0,
};
window.HERON_STATE = state;

const labels = {
  1: { name: 'Single', sub: '1 bracelet' },
  2: { name: 'Wear + spare', sub: '2 bracelets' },
  3: { name: 'The set', sub: '3 bracelets' },
};

// ---------- Cart fetching ----------

async function fetchCart() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  const cart = await res.json();
  if (cart.currency) {
    CART_CURRENCY = cart.currency;
    FREE_SHIPPING_THRESHOLD = FREE_SHIPPING_THRESHOLDS[cart.currency] || 40;
  }
  return cart;
}

async function addToCart(variantId, quantity) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity }),
  });
  return res.json();
}

async function updateLineQty(line, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line, quantity }),
  });
  return res.json();
}

async function updateCartCount() {
  const cart = await fetchCart();
  const badge = $('#cartCount');
  if (!badge) return;
  badge.textContent = String(cart.item_count);
  badge.classList.toggle('hidden', cart.item_count === 0);
}

// ---------- Mobile menu ----------

const mobileMenuBtn = $('#mobileMenuBtn');
const mobileMenu = $('#mobileMenu');
if (mobileMenuBtn && mobileMenu) {
  const iconOpen = mobileMenuBtn.querySelector('.menu-icon-open');
  const iconClose = mobileMenuBtn.querySelector('.menu-icon-close');
  const setMenuOpen = (open) => {
    mobileMenu.classList.toggle('open', open);
    mobileMenuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    mobileMenuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (iconOpen) iconOpen.classList.toggle('hidden', open);
    if (iconClose) iconClose.classList.toggle('hidden', !open);
  };
  mobileMenuBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    setMenuOpen(!mobileMenu.classList.contains('open'));
  });
  mobileMenu.querySelectorAll('a').forEach((a) => {
    a.addEventListener('click', () => setMenuOpen(false));
  });
  document.addEventListener('click', (e) => {
    if (!mobileMenu.classList.contains('open')) return;
    if (mobileMenu.contains(e.target) || mobileMenuBtn.contains(e.target)) return;
    setMenuOpen(false);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu.classList.contains('open')) setMenuOpen(false);
  });
}

// ---------- Bundle picker ----------

function selectBundle(card) {
  $$('.bundle-card').forEach((c) => {
    c.classList.remove('active');
    c.setAttribute('aria-checked', 'false');
    c.style.boxShadow = '';
  });
  card.classList.add('active');
  card.setAttribute('aria-checked', 'true');
  card.style.boxShadow = '0 0 0 1.5px var(--ink)';
  state.bundle = parseInt(card.dataset.bundle, 10);

  // Display the formatted price baked into the card by Liquid (already in shop currency)
  const display = card.dataset.displayPrice || '';
  const mainPrice = $('#mainCtaPrice');
  if (mainPrice && display) mainPrice.textContent = display;
  const floatPrice = $('#floatingPrice');
  if (floatPrice && display) floatPrice.textContent = display;
}

$$('.bundle-card').forEach((card) => {
  card.addEventListener('click', () => selectBundle(card));
});

window.addEventListener('DOMContentLoaded', () => {
  const initial = $('.bundle-card.active') || $('.bundle-card[data-bundle="1"]');
  if (initial) selectBundle(initial);
});

// ---------- Variant selection (real Shopify variant resolution) ----------

let _CACHED_PRODUCT = null;
function getProduct() {
  if (_CACHED_PRODUCT) return _CACHED_PRODUCT;
  const el = $('[data-product-json]');
  if (!el) return null;
  try { _CACHED_PRODUCT = JSON.parse(el.textContent); } catch { return null; }
  return _CACHED_PRODUCT;
}

function findMatchingVariant(product, selected) {
  return product.variants.find(v => {
    return product.options.every((opt, i) => {
      const optName = typeof opt === 'string' ? opt : opt.name;
      if (selected[optName] === undefined) return true;
      return v.options[i] === selected[optName];
    });
  });
}

function getSelectedOptions() {
  const selected = {};
  $$('.type-pill.active').forEach(b => selected['Type'] = b.dataset.type);
  $$('.colour-swatch.active').forEach(b => selected['Colour'] = b.dataset.colour);
  return selected;
}

function syncVariant() {
  const product = getProduct();
  if (!product) return;
  const match = findMatchingVariant(product, getSelectedOptions());
  if (!match) return;

  state.variantId = match.id;
  state.variantPrice = match.price;

  // Update URL so refresh keeps the selection
  if (history.replaceState) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    history.replaceState({}, '', url);
  }

  // Jump carousel to the slide for this variant's featured image
  if (match.featured_image && match.featured_image.src) {
    jumpGalleryToVariantImage(match);
  }

  // Update availability state on add-to-cart button
  const addBtn = $('#mainAddToCart');
  const floatBtn = $('#floatingAdd');
  if (!match.available) {
    [addBtn, floatBtn].forEach(b => {
      if (!b) return;
      b.disabled = true;
      b.classList.add('opacity-50', 'cursor-not-allowed');
    });
  } else {
    [addBtn, floatBtn].forEach(b => {
      if (!b) return;
      b.disabled = false;
      b.classList.remove('opacity-50', 'cursor-not-allowed');
    });
  }
}

$$('.type-pill').forEach(btn => {
  btn.addEventListener('click', () => {
    $$('.type-pill').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const eyebrow = $('#heroEyebrow');
    if (eyebrow) eyebrow.textContent = `${btn.dataset.type} Diabetes Bracelet`;
    syncVariant();
  });
});

$$('.colour-swatch').forEach(swatch => {
  swatch.addEventListener('click', () => {
    $$('.colour-swatch').forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');
    syncVariant();
  });
});

window.addEventListener('DOMContentLoaded', () => {
  // Initialise variant from URL ?variant=ID
  const product = getProduct();
  if (product) {
    const params = new URLSearchParams(window.location.search);
    const variantId = parseInt(params.get('variant'), 10);
    if (variantId) {
      const variant = product.variants.find(v => v.id === variantId);
      if (variant) {
        product.options.forEach((opt, i) => {
          const optName = typeof opt === 'string' ? opt : opt.name;
          const value = variant.options[i];
          if (optName === 'Type') {
            $$('.type-pill').forEach(b => b.classList.toggle('active', b.dataset.type === value));
          } else if (optName === 'Colour') {
            $$('.colour-swatch').forEach(s => s.classList.toggle('active', s.dataset.colour === value));
          }
        });
      }
    }
  }
  syncVariant();
});

// ---------- Gallery thumbnails (click to scroll carousel to slide) ----------

const galleryTrack = $('#galleryTrack');

$$('.gallery-thumb').forEach(thumb => {
  let pointerDownAt = null;
  let dragged = false;
  thumb.addEventListener('pointerdown', (e) => {
    pointerDownAt = { x: e.clientX, y: e.clientY };
    dragged = false;
  });
  thumb.addEventListener('pointermove', (e) => {
    if (!pointerDownAt) return;
    const dx = Math.abs(e.clientX - pointerDownAt.x);
    const dy = Math.abs(e.clientY - pointerDownAt.y);
    if (dx > 3 || dy > 3) dragged = true;
  });
  thumb.addEventListener('pointercancel', () => { pointerDownAt = null; dragged = false; });
  thumb.addEventListener('click', (e) => {
    const wasDrag = dragged;
    pointerDownAt = null;
    dragged = false;
    if (wasDrag) { e.preventDefault(); return; }
    const slideIdx = parseInt(thumb.dataset.slide, 10);
    const slides = $$('.gallery-slide');
    if (!galleryTrack || !slides[slideIdx]) return;
    galleryTrack.scrollTo({ left: slides[slideIdx].offsetLeft - galleryTrack.offsetLeft, behavior: 'smooth' });
    $$('.gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Sync thumb-active state when user swipes the carousel
if (galleryTrack) {
  let scrollTimer;
  galleryTrack.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const slides = $$('.gallery-slide');
      const idx = Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
      $$('.gallery-thumb').forEach((t, i) => t.classList.toggle('active', i === idx));
    }, 80);
  }, { passive: true });
}

// Variant change should jump the carousel to that variant's image
function jumpGalleryToVariantImage(variant) {
  if (!variant.featured_image || !galleryTrack) return;
  const product = getProduct();
  if (!product) return;
  const idx = product.images.findIndex(img => {
    const imgSrc = typeof img === 'string' ? img : img.src;
    return imgSrc && imgSrc.includes(variant.featured_image.src.split('?')[0]);
  });
  if (idx < 0) return;
  const slides = $$('.gallery-slide');
  if (!slides[idx]) return;
  galleryTrack.scrollTo({ left: slides[idx].offsetLeft - galleryTrack.offsetLeft, behavior: 'smooth' });
}

// ---------- Add to cart ----------

async function addCurrentToCart() {
  if (!state.variantId) {
    const product = getProduct();
    if (product) state.variantId = product.variants[0]?.id;
  }
  if (!state.variantId) return;
  await addToCart(state.variantId, state.bundle);
  await updateCartCount();
  startUrgencyTimer();
  openDrawer();
}

$('#mainAddToCart')?.addEventListener('click', addCurrentToCart);
$('#floatingAdd')?.addEventListener('click', addCurrentToCart);

// ---------- Cart drawer ----------

const drawer = $('#drawer');
const overlay = $('#drawerOverlay');

async function openDrawer() {
  if (!drawer || !overlay) return;
  drawer.classList.add('open');
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  await renderDrawer();
}
function closeDrawer() {
  if (!drawer || !overlay) return;
  drawer.classList.remove('open');
  overlay.classList.remove('open');
  document.body.style.overflow = '';
}
$('#cartBtn')?.addEventListener('click', openDrawer);
$('#drawerClose')?.addEventListener('click', closeDrawer);
overlay?.addEventListener('click', closeDrawer);

async function renderDrawer() {
  const body = $('#drawerBody');
  const foot = $('#drawerFoot');
  if (!body || !foot) return;
  const cart = await fetchCart();

  if (cart.item_count === 0) {
    body.innerHTML = '<div class="py-12 text-center text-sm text-ink-muted">Your cart is empty.</div>';
    foot.hidden = true;
    const upsells = $('#drawerUpsells');
    if (upsells) upsells.hidden = true;
    return;
  }

  // Products whose link should NOT be clickable in the cart (e.g. free add-ons)
  const NON_CLICKABLE_PRODUCT_IDS = new Set([16280472060249]);

  body.innerHTML = cart.items.map((item, idx) => {
    const meta = item.variant_title ? `<p class="text-[11px] text-ink-muted mt-1">${item.variant_title}</p>` : '';
    const isClickable = !NON_CLICKABLE_PRODUCT_IDS.has(item.product_id);
    const imgInner = item.image ? `<img src="${item.image}" alt="" class="w-20 h-20 object-cover rounded-md" />` : '';
    const img = item.image
      ? (isClickable
          ? `<a href="${item.url}" class="flex-shrink-0">${imgInner}</a>`
          : `<div class="flex-shrink-0">${imgInner}</div>`)
      : '';
    const titleHtml = isClickable
      ? `<a href="${item.url}" class="font-display text-base leading-tight flex-1 min-w-0 hover:underline">${item.product_title}</a>`
      : `<span class="font-display text-base leading-tight flex-1 min-w-0">${item.product_title}</span>`;
    return `
      <div class="flex gap-4 py-5 border-b border-line/60">
        ${img}
        <div class="flex-1 min-w-0 flex flex-col">
          <div class="flex items-start justify-between gap-3">
            ${titleHtml}
            <button data-remove="${idx + 1}" aria-label="Remove" class="text-ink-faint hover:text-ink">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="6" y1="18" x2="18" y2="6"/></svg>
            </button>
          </div>
          ${meta}
          <div class="flex items-center justify-between mt-3 gap-3">
            <div class="inline-flex items-center border border-line rounded-full overflow-hidden text-sm">
              <button data-decrease="${idx + 1}" class="px-3 py-1">−</button>
              <span class="px-2">${item.quantity}</span>
              <button data-increase="${idx + 1}" class="px-3 py-1">+</button>
            </div>
            <div class="flex items-baseline gap-2">
              ${item.original_line_price > item.final_line_price ? `<span class="font-display text-base text-ink-muted line-through">${fmt(item.original_line_price)}</span>` : ''}
              <span class="font-display text-base">${fmt(item.final_line_price)}</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }).join('');

  body.querySelectorAll('[data-remove]').forEach(btn => {
    btn.addEventListener('click', async () => {
      await updateLineQty(parseInt(btn.dataset.remove, 10), 0);
      await renderDrawer();
      await updateCartCount();
    });
  });
  body.querySelectorAll('[data-decrease]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.decrease, 10);
      const item = cart.items[line - 1];
      await updateLineQty(line, item.quantity - 1);
      await renderDrawer();
      await updateCartCount();
    });
  });
  body.querySelectorAll('[data-increase]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.increase, 10);
      const item = cart.items[line - 1];
      await updateLineQty(line, item.quantity + 1);
      await renderDrawer();
      await updateCartCount();
    });
  });

  await renderUpsells(cart);

  foot.hidden = false;
  $('#drawerTotal').textContent = fmt(cart.total_price);

  const savingsRow = $('#drawerSavingsRow');
  if (cart.total_discount > 0) {
    savingsRow.classList.remove('hidden');
    savingsRow.classList.add('flex');
    $('#drawerSavings').textContent = '−' + fmt(cart.total_discount);
  } else {
    savingsRow.classList.add('hidden');
    savingsRow.classList.remove('flex');
  }

  const total = cart.total_price / 100;
  const remaining = FREE_SHIPPING_THRESHOLD - total;
  const shipping = $('#drawerShipping');
  const fill = $('#drawerBarFill');
  if (shipping && fill) {
    if (remaining > 0) {
      shipping.textContent = `${fmt(remaining * 100)} away from free delivery`;
      fill.style.width = `${(total / FREE_SHIPPING_THRESHOLD) * 100}%`;
    } else {
      shipping.textContent = 'Free delivery unlocked';
      fill.style.width = '100%';
    }
  }
}

// ---------- Upsells (cart-aware: bracelet → matching keychain) ----------

// Candidate keychain handles to try (first one that resolves wins)
const UPSELL_KEYCHAIN_HANDLES = {
  bloodThinner: ['blood-thinner-keychain', 'bloodthinner-keychain'],
  diabetes: ['diabetes-keychain', 'blood-thinner-keychain-1'],
};

const _upsellCache = {};

async function fetchProduct(handle) {
  if (_upsellCache[handle] !== undefined) return _upsellCache[handle];
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) {
      _upsellCache[handle] = null;
      return null;
    }
    const product = await res.json();
    _upsellCache[handle] = product;
    return product;
  } catch (e) {
    _upsellCache[handle] = null;
    return null;
  }
}

async function fetchProductTryHandles(handles) {
  for (const handle of handles) {
    const product = await fetchProduct(handle);
    if (product) return product;
  }
  return null;
}

function findVariantByOption(product, optionValue) {
  if (!product || !product.variants) return null;
  const target = String(optionValue).toLowerCase();
  return product.variants.find(v =>
    (v.options || []).some(o => String(o).toLowerCase() === target) ||
    (v.title || '').toLowerCase().includes(target)
  );
}

// Find the alternate-colour variant of the same product.
// Strategy: identify which option is the Colour, then find a variant that
// matches the current variant on every option EXCEPT colour (where it must differ).
function findAlternateColourVariant(product, currentVariantId) {
  if (!product || !product.variants) return null;
  const current = product.variants.find(v => v.id === currentVariantId);
  if (!current) return null;

  // product.options can be ["Colour","Type"] or [{name:"Colour"}, ...]
  const optionNames = (product.options || []).map(o =>
    typeof o === 'string' ? o : (o && o.name ? o.name : '')
  );
  let colourIdx = optionNames.findIndex(n => /colou?r/i.test(n));

  // Fallback: if no obvious colour option, just return any other available variant
  if (colourIdx === -1) {
    return product.variants.find(v => v.id !== currentVariantId && v.available !== false) || null;
  }

  const currentOptions = current.options || [];
  return product.variants.find(v => {
    if (v.id === currentVariantId) return false;
    if (v.available === false) return false;
    const opts = v.options || [];
    if (opts.length !== currentOptions.length) return false;
    for (let i = 0; i < opts.length; i++) {
      if (i === colourIdx) {
        if (opts[i] === currentOptions[i]) return false; // colour must differ
      } else {
        if (opts[i] !== currentOptions[i]) return false; // other options must match
      }
    }
    return true;
  }) || null;
}

// Detect alternate-colour upsell from a bracelet in the cart.
// Returns the handle + current variant id; the alternate is resolved against
// the fetched product so colour names don't have to be hardcoded.
function detectColourSwapFromItem(item) {
  const title = (item.product_title || '').toLowerCase();
  if (title.includes('keychain') || title.includes('key chain') || title.includes('key-chain')) return null;
  if (!title.includes('bracelet')) return null;
  if (!item.handle || !item.variant_id) return null;
  return { handle: item.handle, currentVariantId: item.variant_id };
}

// Detect whether a cart item is a bracelet that should trigger an upsell
function detectUpsellFromItem(item) {
  const title = (item.product_title || '').toLowerCase();
  const variant = (item.variant_title || '').toLowerCase();

  // Skip keychains themselves
  if (title.includes('keychain') || title.includes('key chain') || title.includes('key-chain')) return null;

  // Must be a bracelet (or product without "keychain")
  const isBracelet = title.includes('bracelet') || !title.includes('keychain');
  if (!isBracelet) return null;

  if (title.includes('blood') && title.includes('thinner')) {
    return { kind: 'bloodThinner' };
  }

  if (title.includes('diabetes') || title.includes('diabetic')) {
    if (variant.includes('type 1') || variant.includes('type1') || variant.includes('t1')) {
      return { kind: 'diabetes', option: 'Type 1' };
    }
    if (variant.includes('type 2') || variant.includes('type2') || variant.includes('t2')) {
      return { kind: 'diabetes', option: 'Type 2' };
    }
    // Type unspecified — default to Type 2 (more common)
    return { kind: 'diabetes', option: 'Type 2' };
  }

  return null;
}

async function renderUpsells(cart) {
  const container = $('#drawerUpsells');
  const list = $('#drawerUpsellsList');
  if (!container || !list) return;

  list.innerHTML = '';

  const cartTitlesLower = cart.items.map(i => (i.product_title || '').toLowerCase());
  const cartVariantIds = new Set(cart.items.map(i => i.variant_id));
  const seen = new Set();
  const candidates = [];

  // Pass 1: alternate-colour bracelet upsells
  for (const item of cart.items) {
    const swap = detectColourSwapFromItem(item);
    if (!swap) continue;
    const key = `swap::${swap.handle}::${swap.currentVariantId}`;
    if (seen.has(key)) continue;
    seen.add(key);
    candidates.push({ kind: 'colourSwap', ...swap });
  }

  // Pass 2: matching-keychain upsells (existing behaviour)
  for (const item of cart.items) {
    const detected = detectUpsellFromItem(item);
    if (!detected) continue;
    const key = `keychain::${detected.kind}::${detected.option || ''}`;
    if (seen.has(key)) continue;
    seen.add(key);

    const keyword = detected.kind === 'bloodThinner' ? 'blood thinner' : 'diabetes';
    const alreadyInCart = cartTitlesLower.some(t => t.includes(keyword) && t.includes('keychain'));
    if (alreadyInCart) continue;

    candidates.push({ kind: 'keychain', sub: detected.kind, option: detected.option });
  }

  if (candidates.length === 0) {
    container.hidden = true;
    return;
  }

  const cards = await Promise.all(candidates.map(async candidate => {
    let product, variant;

    if (candidate.kind === 'colourSwap') {
      product = await fetchProduct(candidate.handle);
      if (!product) return '';
      variant = findAlternateColourVariant(product, candidate.currentVariantId);
      if (!variant) return '';
      // Skip if the alternate variant is already in cart
      if (cartVariantIds.has(variant.id)) return '';
    } else {
      const handles = UPSELL_KEYCHAIN_HANDLES[candidate.sub];
      if (!handles) return '';
      product = await fetchProductTryHandles(handles);
      if (!product) return '';
      variant = candidate.option ? findVariantByOption(product, candidate.option) : product.variants[0];
      if (!variant) return '';
    }

    const variantImage = variant.featured_image && variant.featured_image.src
      ? variant.featured_image.src
      : product.featured_image;
    const img = variantImage
      ? `<img src="${variantImage}" alt="" class="w-14 h-14 object-cover rounded flex-shrink-0" />`
      : `<div class="w-14 h-14 rounded bg-bone flex-shrink-0"></div>`;
    const variantLabel = variant.title && variant.title !== 'Default Title'
      ? `<p class="text-[11px] text-ink-muted mt-0.5">${variant.title}</p>`
      : '';
    const linkUrl = `${product.url}?variant=${variant.id}`;
    return `
      <div class="flex items-center gap-3 py-2">
        <a href="${linkUrl}" class="flex-shrink-0">${img}</a>
        <div class="flex-1 min-w-0">
          <a href="${linkUrl}" class="font-display text-sm leading-tight hover:underline">${product.title}</a>
          ${variantLabel}
          <p class="text-xs mt-0.5">${fmt(variant.price)}</p>
        </div>
        <button data-add-upsell="${variant.id}" class="self-center text-xs font-medium bg-ink text-paper rounded-full px-5 py-1.5 hover:bg-ink-soft transition flex-shrink-0">
          Add
        </button>
      </div>
    `;
  }));

  list.innerHTML = cards.filter(Boolean).join('');
  container.hidden = list.innerHTML.trim() === '';

  list.querySelectorAll('[data-add-upsell]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = parseInt(btn.dataset.addUpsell, 10);
      btn.disabled = true;
      btn.textContent = 'Adding…';
      await addToCart(variantId, 1);
      await renderDrawer();
      await updateCartCount();
    });
  });
}

// ---------- Urgency countdown timer ----------

let urgencyInterval = null;

function startUrgencyTimer() {
  if (!localStorage.getItem(URGENCY_KEY)) {
    localStorage.setItem(URGENCY_KEY, String(Date.now()));
  }
  if (urgencyInterval) return;
  tickUrgency();
  urgencyInterval = setInterval(tickUrgency, 1000);
}

function stopUrgencyTimer() {
  if (urgencyInterval) clearInterval(urgencyInterval);
  urgencyInterval = null;
  localStorage.removeItem(URGENCY_KEY);
}

function tickUrgency() {
  const start = parseInt(localStorage.getItem(URGENCY_KEY), 10);
  if (!start) return;
  const remaining = URGENCY_DURATION_MS - (Date.now() - start);
  const display = $('#drawerUrgencyTimer');
  if (!display) return;
  if (remaining <= 0) {
    // Restart so the urgency feels live
    localStorage.setItem(URGENCY_KEY, String(Date.now()));
    return;
  }
  const mins = Math.floor(remaining / 60000);
  const secs = Math.floor((remaining % 60000) / 1000);
  display.textContent = `${mins}:${String(secs).padStart(2, '0')}`;
}

// On load, resume timer if cart already has items
window.addEventListener('DOMContentLoaded', async () => {
  await updateCartCount();
  const cart = await fetchCart();
  if (cart.item_count > 0 && localStorage.getItem(URGENCY_KEY)) {
    startUrgencyTimer();
  }
});

// ---------- Topbar show/hide on scroll direction ----------

(function initTopbarScroll() {
  const topbar = document.getElementById('siteTopbar');
  if (!topbar) return;
  const mobileMenuEl = document.getElementById('mobileMenu');
  const TOP_THRESHOLD = 80;
  const DELTA = 5;
  let lastY = window.scrollY;

  const setTopbarHeight = () => {
    document.documentElement.style.setProperty('--topbar-h', topbar.offsetHeight + 'px');
  };
  setTopbarHeight();
  window.addEventListener('resize', setTopbarHeight, { passive: true });
  if (window.ResizeObserver) {
    new ResizeObserver(setTopbarHeight).observe(topbar);
  }

  const onScroll = () => {
    const y = window.scrollY;
    const menuOpen = mobileMenuEl && mobileMenuEl.classList.contains('open');
    if (menuOpen || y <= TOP_THRESHOLD) {
      topbar.classList.remove('is-hidden');
      lastY = y;
    } else if (y > lastY + DELTA) {
      topbar.classList.add('is-hidden');
      lastY = y;
    } else if (y < lastY - DELTA) {
      topbar.classList.remove('is-hidden');
      lastY = y;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
})();

// ---------- Floating CTA show/hide based on scroll position ----------

const floatingCta = $('#floatingCta');
const shopSection = $('#shop');
if (floatingCta && shopSection) {
  const checkFloating = () => {
    const rect = shopSection.getBoundingClientRect();
    const inView = rect.bottom > 0 && rect.top < window.innerHeight;
    floatingCta.classList.toggle('show', !inView && rect.top < 0);
  };
  window.addEventListener('scroll', checkFloating, { passive: true });
  window.addEventListener('resize', checkFloating);
  window.addEventListener('DOMContentLoaded', checkFloating);
}
